import React from "react";
import AxionSelect from "../controls/AxionSelect";
import messages from "./messages";
import { FormattedMessage, useIntl } from "react-intl";
import { IconButton, Box } from "@mui/material";
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { getISOWeek } from 'date-fns';

export default function WeekPicker(props) {
    const { weeks, setSelectedWeekStartDate, setSelectedWeekEndDate, selectedWeek, setSelectedWeek } = props;
    const intl = useIntl();
    let options = [ { id: 1, title: intl.formatMessage(messages.thisWeek) } ];
    options = options.concat(weeks.map((week) => ({
        id: week.weekNumber,
        title: `${intl.formatMessage(messages.week)} ${getISOWeek(new Date(week.startDate))} (${week.startDate} --- ${week.endDate})`
    })));

    const handlePreviousWeek = () => {
        const selected = weeks.find(week => week.weekNumber === selectedWeek);
        if (selected) {
            const previousWeek = weeks.find(week => week.weekNumber === selected.weekNumber - 1);
            if (previousWeek) {
                setSelectedWeek(previousWeek.weekNumber);
                setSelectedWeekStartDate(previousWeek.startDate + "T00:00:00");
                setSelectedWeekEndDate(previousWeek.endDate + "T23:59:59");
            }
        }
        else {
            setSelectedWeek(0);
            setSelectedWeekStartDate(weeks[0].startDate + "T00:00:00");
            setSelectedWeekEndDate(weeks[0].endDate + "T23:59:59");
        }

    }

    const handleNextWeek = () => {
        const selected = weeks.find(week => week.weekNumber === selectedWeek);
        if (selected) {
            const nextWeek = weeks.find(week => week.weekNumber === selected.weekNumber + 1);
            if (nextWeek) {
                setSelectedWeek(nextWeek.weekNumber);
                setSelectedWeekStartDate(nextWeek.startDate + "T00:00:00");
                setSelectedWeekEndDate(nextWeek.endDate + "T23:59:59");
            }
        }
    }

    return (
        <Box mb={1}>
            <IconButton
                onClick={handlePreviousWeek}
                sx={{ marginRight: "10px" }}>
                    <ArrowCircleLeftIcon fontSize="large" />
            </IconButton>
            <AxionSelect
                label={<FormattedMessage {...messages.week} />}
                value={selectedWeek}
                onChange={(e) => {
                    const selected = weeks.find(week => week.weekNumber === e.target.value);
                    setSelectedWeekStartDate(selected ? selected.startDate + "T00:00:00" : null);
                    setSelectedWeekEndDate(selected ? selected.endDate + "T23:59:59" : null);
                    setSelectedWeek(e.target.value);
                }}
                showNoneOption={false}
                sx={{ width: "270px" }}
                options={options}
                />
            <IconButton
                onClick={handleNextWeek}
                disabled={selectedWeek === weeks[0].weekNumber || selectedWeek === 1}
                sx={{ marginLeft: "10px" }}>
                    <ArrowCircleRightIcon fontSize="large" />
            </IconButton>
        </Box>
    );
}
